<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Companies</span>
    </div>
    <div nz-col nzSpan="8">
        
    </div>
    <div nz-col nzSpan="10">
        <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button nzType="primary" (click)="showCreateModal()">
                <i nz-icon nzType="file-add" nzTheme="outline" style="color: white;"></i> Add New Company
            </button>
        </div>
    </div>
</div>

<nz-table #companyTable [nzData]="companyMaster" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true" >
    <thead>
        <tr>        
            <th *ngFor="let column of listOfColumn"    
                [nzShowSort]="column.allowSorting"
                [nzSortFn]="column.compare" 
                [nzSortPriority]="column.priority" style="padding: 5px;">
                {{ column.title }}
            </th>           
        </tr>        
    </thead>
    <tbody>
        <tr *ngFor="let data of companyTable.data">
            <td>{{ data.Company_Name}} </td>
            <td>{{ data.Company_Acronym }} </td>
            <td>{{ data.CompStatus }}</td>            
            <td>
                <div *ngIf="data.CompStatus == 'Active'" class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;"> 
                    <button  nz-button nzType="primary" [nzSize]="'small'" style="margin-right: 5px;" (click)="showEditModal(data)">
                        <i nz-icon nzType="edit" nzTheme="outline"  style="color: white;"></i> Edit
                    </button>  
                    <button nz-button nzType="primary" [nzSize]="'small'" nzDanger (click)="showDeactivateModal(data)">
                        <i nz-icon nzType="stop"  style="color: white;"></i> De-Activate
                    </button> 
                </div>
            </td>
        </tr>
    </tbody>
</nz-table>


<nz-modal [(nzVisible)]="isVisible" nzTitle="{{ isEditMode ? 'Edit Company' : 'Add New Company' }}" (nzOnCancel)="handleCancel()" [nzClosable]="false">
    <div *nzModalContent>
      <form [formGroup]="companyForm">
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">Company Name<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <input nz-input formControlName="companyName" type="text" class="form-control" placeholder="Enter Company Name" />
            <div class="text-danger">{{ duplicateCompErrMsg }}</div>
            <div *ngIf="companyForm.get('companyName')?.touched && companyForm.get('companyName')?.invalid">
              <small class="text-danger" *ngIf="companyForm.get('companyName')?.errors?.['required']">Company Name is required.</small>
              <small class="text-danger" *ngIf="companyForm.get('companyName')?.errors?.['maxlength']">Company Name cannot exceed 50 characters.</small>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-4">
            <label class="required">Company Acronym<span class="text-danger">*</span></label>
          </div>
          <div class="col-md-8">
            <input nz-input formControlName="companyAcronym" type="text" class="form-control" placeholder="Enter Company Acronym" maxlength="10"/>
            <div class="text-danger">{{ duplicateAcronymErrMsg }}</div>
            <div *ngIf="companyForm.get('companyAcronym')?.touched && companyForm.get('companyAcronym')?.invalid">
              <small class="text-danger" *ngIf="companyForm.get('companyAcronym')?.errors?.['required']">Company Acronym is required.</small>
              <small class="text-danger" *ngIf="companyForm.get('companyAcronym')?.errors?.['maxlength']">Company Acronym cannot exceed 3 characters.</small>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
      <button nz-button nzType="primary" [disabled]="companyForm.invalid" (click)="handleOk()" [nzLoading]="isConfirmLoading">
        {{ isEditMode ? 'Update' : 'Create' }}
      </button>
    </div>
  </nz-modal>